import React from "react"

const VerticalSign = (props) => (
  <div>vert</div>
)

export default VerticalSign